<div class="remove-service-dialog">
  <div class="remove-service-dialog__content">
    <div class="remove-service-dialog__header">
      <mat-icon class="remove-service-dialog__warning-icon">warning</mat-icon>
      <h2 class="remove-service-dialog__title">{{ 'SCHEDULING.REMOVE_SERVICE_TITLE' | translate }}</h2>
    </div>

    <p class="remove-service-dialog__message">
      {{ 'SCHEDULING.REMOVE_SERVICE_CONFIRMATION' | translate }}
    </p>

    <div class="remove-service-dialog__service-row">
      <span class="remove-service-dialog__service-name">{{ data.serviceName }}</span>
    </div>
  </div>

  <div class="remove-service-dialog__actions">
    <button
      mat-flat-button
      class="remove-service-dialog__remove-btn"
      (click)="onRemove()"
    >
      {{ 'SCHEDULING.REMOVE' | translate }}
    </button>
    <button mat-stroked-button class="remove-service-dialog__cancel-btn" (click)="onCancel()">{{ 'SCHEDULING.CANCEL' | translate }}</button>
  </div>
</div>
